import React, { useState, useEffect, useContext } from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import api from '../../services/api';
import Cookies from 'js-cookie';

//---------COMPONENTES----------------------
import Header from '../../componentes/Header/index';
import Footer from '../../componentes/Footer/index';

import { PesquisaPlaca } from "../../componentes/Pesquisas/PesquisaPlaca";
import {ModalCotacao_PREVIEW} from '../../componentes/Modal/ModalCota_PREVIEW';
import { FunctModal } from '../../componentes/Functions';

//---------SERVICES--------------------------
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { ApiUsuario } from '../../services/FiltrosApi/logado';

// ------------------------------------------
export function COTACAO_SIMPLES() {
    const { state, dispatch } = useContext(Context);
    const { cliente, usuario, logado } = state.cliente;

    const { parametroInit, playmodal, listaPesquisa, playLista } = state.parametros;
    const {
        pesquisaIdVeiculo,
        pesquisaIdUsuario,
    } = parametroInit;

    const { id_Usuario } = usuario;

    const { LogUsuario } = ApiUsuario();
    const { FecharModal } = FunctModal();

    const { pesqIDveiculo } = Api_Veiculos();
    const { pesqidcliente } = Api_Clientes();
    const { PesqIdEvento, BuscaTodosEventos } = ApiEvento();
    // ----------------------
    const [buscandoDadosPlaca, setBuscandoDadosPlaca] = useState(false);
    const [sucessoBuscaPlaca, setSucessoBuscaPlaca] = useState(false);
    const [dadosDivergentes, setDadosDivergentes] = useState(false);
    const [dadosCompletos, setdadosCompletos] = useState(false);
    const [erroBuscaPlaca, setErroBuscaPlaca] = useState('');
    const [situacaoDivergente, setSituacaoDivergente] = useState(false); 
    const [maioresScoresFipe, setmaioresScoresFipe] = useState([]);
    const [valorMensalCotac, setvalorMensal] = useState('');

    // --------------
    const token = Cookies.get('token');

    useEffect(() => {
        if (token) {
            LogUsuario(token);
        } else {
            dispatch({
                type: 'set_logado',
                payload: { ...logado, conectado: false }
            });
        }
    }, [token]);

    //-----------------------------------------------
    useEffect(() => {
        if (pesquisaIdVeiculo) {
            pesqIDveiculo();
        }
    }, [pesquisaIdVeiculo])

    // -------------------
    useEffect(() => {
        if (pesquisaIdUsuario) {
            pesqIdUsuario();
        }
    }, [pesquisaIdUsuario])

    //--Pesquisar Usuario por id----------------------------
    async function pesqIdUsuario() {
        if (id_Usuario) {
            await api.get(`/usuario/id/${id_Usuario}`)
            .then(res => {
                dispatch({
                    type: 'set_ListaPesquisa',
                    payload: { ...listaPesquisa, listaUsuario: [res.data] }
                });
                dispatch({
                    type: 'set_playLista',
                    payload: { ...playLista, playListaUsuario: true }
                });
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, pesquisaIdUsuario: false }
                });

            })
        }
    };

    // ------------------------------
    useEffect(() => {
        pesqidcliente();
    }, [cliente.id_Cliente]);

    // ---------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
                playModalDetalhesEven: false,
            }
        });
    }, [parametroInit.filtroPlaca]);
    // --------

    useEffect(() => {
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalEven: true,
            }
        });
    }, [])

    //###################################################################################################
    return (
        <S.App>
            <Header playLogo={true} />
            <S.body>
                <S.VistoriaModal>
                     {/* --------- PLACA---------- */}
                    <S.div3>
                        <PesquisaPlaca
                        titulo = "PLACA:"
                        setBuscandoDadosPlaca={setBuscandoDadosPlaca}
                        setSucessoBuscaPlaca={setSucessoBuscaPlaca}
                        setDadosDivergentes={setDadosDivergentes}
                        dadosCompletos={dadosCompletos}
                        buscandoDadosPlaca={buscandoDadosPlaca}
                        setdadosCompletos={setdadosCompletos}
                        setSituacaoDivergente={setSituacaoDivergente}
                        setErroBuscaPlaca={setErroBuscaPlaca}
                        maioresScoresFipe={maioresScoresFipe}
                        setmaioresScoresFipe={setmaioresScoresFipe}  
                        valorMensalCotac={valorMensalCotac}
                        setvalorMensal={setvalorMensal}
                        />
                    </S.div3>
                    <S.Modal>
                        <ModalCotacao_PREVIEW
                        fazerCotacao={true}
                        FecharModal={FecharModal}
                        Lupa={true}
                        PesqIdEvento={PesqIdEvento}
                        BuscaTodosEventos={BuscaTodosEventos}

                        dadosCompletos={dadosCompletos} 
                        erroBuscaPlaca={erroBuscaPlaca}
                        sucessoBuscaPlaca={sucessoBuscaPlaca}
                        dadosDivergentes={dadosDivergentes}
                        situacaoDivergente={situacaoDivergente}
                        maioresScoresFipe={maioresScoresFipe}
                        buscandoDadosPlaca={buscandoDadosPlaca}
                        valorMensalCotac={valorMensalCotac}
                        />
                    </S.Modal>

                </S.VistoriaModal>
            </S.body>
            <Footer />
        </S.App>
    )
}